import { toast } from "react-toastify";
import ConfirmationModal from "../components/ConfirmationModal/confirmationModal";

export const confirmationHandler = (title, message, onConfirm) => {
  return new Promise((resolve) => {
    const toastId = toast(
      ({ closeToast }) => (
        <ConfirmationModal 
          title={title} 
          message={message} 
          onConfirm={() => {
            if (onConfirm) onConfirm();
            resolve(true);
          }}
          onCancel={() => {
            resolve(false);
          }}
          toast={toast}
        />
      ),
      {
        toastId: "confirmationToast",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
        position: "top-center"
      }
    );
    
    
    return toastId;
  });
};

